import React from "react";
import { Link, useParams } from "react-router-dom";
import Seo from "@/components/Seo";
import { PublicShell } from "@/public/PublicChrome";
import { Section, Eyebrow, Lede, Reveal, Panel, Disclaimer, RelatedLinks } from "@/public/ui";
import { termSeo } from "@/public/seo";
import { TERM_BY_SLUG } from "@/public/glossaryTerms";
import NotFound from "@/public/pages/NotFound";

export default function GlossaryTerm({ slug: fixed }) {
  const params = useParams();
  const t = TERM_BY_SLUG[fixed || params.term];
  if (!t) return <NotFound />;
  return (
    <PublicShell>
      <Seo {...termSeo(t)} noindex={false} />
      <Section className="pt-32 sm:pt-40 pb-16">
        <div className="absolute inset-x-0 top-0 -z-10 h-[340px] bg-[radial-gradient(ellipse_at_top,rgba(6,182,212,0.10),transparent_65%)]" aria-hidden="true" />
        <div className="max-w-3xl">
          <Reveal><Eyebrow><Link to="/glossary" className="hover:underline" data-testid="term-back-glossary">Glossary</Link></Eyebrow></Reveal>
          <Reveal delay={0.05}>
            <h1 className="mt-4 font-heading text-4xl sm:text-5xl font-extrabold tracking-tight text-tc-txt" data-testid="term-title">{t.term}</h1>
          </Reveal>
          <Reveal delay={0.1}><Lede className="mt-6" data-testid="term-short">{t.short}</Lede></Reveal>
          <div className="mt-8 space-y-4 text-tc-sub leading-relaxed" data-testid="term-body">
            {t.body.map((p, i) => <p key={i}>{p}</p>)}
          </div>
          <Panel className="mt-8 p-5"><p className="text-sm text-tc-txt" data-testid="term-example">{t.example}</p></Panel>
          <p className="mt-8 text-sm text-tc-sub">
            New to all of this? <Link to="/learn" className="text-tc-coach underline-offset-4 hover:underline" data-testid="term-learn-link">Start learning trading from zero</Link>.
          </p>
          <Disclaimer className="mt-6">Educational definition. Not financial advice; no real-money execution.</Disclaimer>
        </div>
      </Section>
      <RelatedLinks links={[["Glossary", "/glossary"], ["Learn", "/learn"], ["How It Works", "/how-it-works"], ["Pricing", "/pricing"]]} />
    </PublicShell>
  );
}
